import { createContext } from "react"

import { DragSource } from "shared/types/drag-and-drop/DragSource"

export interface DragSourceDataContextType {
  dragSource: DragSource | null
}

export const DragSourceDataContext = createContext<DragSourceDataContextType>({
  dragSource: null
})
